import { SEND_OTP, SEND_OTP_FAILURE, SEND_OTP_SUCCESS } from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const sendOtpReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEND_OTP:
      return { ...state, loading: true };
    case SEND_OTP_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case SEND_OTP_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default sendOtpReducer;
